import { IMPORT_LIST_COLUMN } from "./actionTypes";

export const setListImportColumn = (field, value) => ({
  type: IMPORT_LIST_COLUMN,
  payload: { field, value },
});
